import { Flex, FlexProps } from "@chakra-ui/react";
import { ReactNode } from "react";

export interface GradientBorderContainerProps extends FlexProps {
  topColor: string;
  bottomColor: string;
  children: ReactNode;
  backgroundDirection?: string;
}

export function GradientBorderContainer({
  children,
  topColor,
  bottomColor,
  backgroundDirection = "to bottom",
  ...props
}: GradientBorderContainerProps) {
  const gradientBorderStyle = {
    isolation: "isolate",
    _before: {
      content: `""`,
      position: "absolute",
      inset: 0,
      padding: "1px",
      borderRadius: "inherit",
      background: `linear-gradient(${backgroundDirection}, ${topColor}, ${bottomColor})`,
      WebkitMask:
        "linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0)",
      WebkitMaskComposite: "xor" as const,
      maskComposite: "exclude" as const,
      pointerEvents: "none",
      zIndex: -1,
    },
  };

  return (
    <Flex
      position={"relative"}
      background={props.backgroundColor}
      sx={gradientBorderStyle}
      {...props}
    >
      {children}
    </Flex>
  );
}
